<template>
  <div class="buy">
    <div class="buy__item-container" v-if="!empty">
      <!-- <p class="points">
        &nbsp; <font-awesome-icon icon="info" /> &nbsp;: هزینه ارسال هنگام تحویل
        دریافت میشود
      </p> -->
      <!-- <p class="points">هزینه ارسال هنگام تحویل دریافت میشود</p> -->
      <div
        class="buy__item-container--items"
        v-for="(item, index) in list"
        :key="(item, index)"
      >
        <div class="buy__item-container--items--image">
          <router-link
            :to="{ name: 'detail', params: { id: item.product.slug } }"
          >
            <img :src="item.product.image" alt="" />
          </router-link>
          <p v-if="item.product.special_sale" class="offeeeer">فروش ویژه</p>
          <p v-if="item.product.special_offer" class="offeeeer">پیشنهاد ویژه</p>
        </div>
        <div class="con11">
          <p
            style="margin-bottom: 1em"
            class="buy__item-container--items--name"
          >
            {{ item.product.name }}
          </p>
          <div
            v-if="item.color != null"
            class="buy__item-container--items--color"
          >
            <div
              class="buy__item-container--items--color-div"
              :style="{ background: item.color.color }"
            ></div>
            <p class="buy__item-container--items--color-name">
              {{ item.color.name }}
            </p>
          </div>
          <p
            v-if="item.essence != null"
            class="buy__item-container--items--inv"
          >
            <font-awesome-icon icon="user-edit" />
            اسانس :{{ item.essence }}
          </p>
          <p class="buy__item-container--items--inv">
            <font-awesome-icon icon="user-edit" />
            گارانتی اصالت و سلامت فیزیکی کالا
          </p>
          <p
            v-if="item.product.inventory > 5"
            class="buy__item-container--items--inv"
          >
            <font-awesome-icon icon="user-edit" />
            موجود در انبار
          </p>
          <p
            v-if="item.product.inventory <= 5 && item.product.inventory != 0"
            class="buy__item-container--items--inv"
          >
            <font-awesome-icon icon="user-edit" />
            تنها
            {{ item.product.inventory.toLocaleString("fa").toPersianDigits() }}
            عدد در انبار باقی مانده
          </p>
          <p
            v-if="item.product.inventory == 0"
            class="buy__item-container--items--inv"
          >
            <font-awesome-icon icon="user-edit" />
            نا موجود
          </p>
          <div class="con2">
            <div class="buy__item-container--items--number">
              <!-- <vue-number-input
                style="z-index:0,font-family:'yekan'"
                :min="1"
                :max="item.product.inventory"
                :value="item.number"
                :inputtable="true"
                inline
                center
                controls
                :id="item.id"
                @change="getValue($event, item.id)"
              ></vue-number-input> -->
              <vue-numeric-input
                :id="item.id"
                class="style2"
                :value="item.number"
                v-model="item.number"
                width="150px"
                :step="1"
                :min="1"
                :max="item.product.inventory"
                align="center"
                @change="updateCart($event, item.id)"
              >
              </vue-numeric-input>
              <input type="hidden" :value="item.id" />
            </div>
            <a
              @click.prevent="deleteCart"
              href=""
              class="buy__item-container--items--delete"
            >
              <font-awesome-icon icon="trash-alt" />
              حذف
              <input type="hidden" :value="item.id" />
            </a>
          </div>
        </div>

        <div class="buy__item-container--items--price">
          <div
            v-if="item.total_price_profit[1] != 0"
            class="buy__item-container--items--price-ben"
          >
            تخفیف
            {{
              item.total_price_profit[1].toLocaleString("fa").toPersianDigits()
            }}
            تومان
          </div>
          <div class="buy__item-container--items--price-pri">
            <span>{{
              item.total_price_profit[0].toLocaleString("fa").toPersianDigits()
            }}</span>
            تومان
          </div>
          <div class="errors" v-if="item.my_errors.length != 0">
            <p
              class="errors-p"
              v-for="(item, index) in item.my_errors"
              :key="(item, index)"
            >
              {{ item }}
            </p>
          </div>
          <div
            class="errors"
            v-if="
              item.number > item.product.inventory &&
              item.product.inventory != 0
            "
          >
            <p class="errors-p">
              شما بیشتر از حد موجود در انبار سفارش داده اید
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="buy__info-container" v-if="!empty">
      <div class="buy__info-container--pri">
        قیمت کالاها ({{ info.co.toLocaleString("fa").toPersianDigits() }})
        <span>{{
          (info.ben + info.total + info.wallet)
            .toLocaleString("fa")
            .toPersianDigits()
        }}</span>
        تومان
      </div>
      <div class="buy__info-container--dec">
        سود شما از این خرید
        <span>{{ info.ben.toLocaleString("fa").toPersianDigits() }}</span>
        تومان
      </div>
      <hr class="hrrrr" />
      <div class="buy__info-container--cash">
        مبلغ قابل پرداخت
        <span>{{ info.total.toLocaleString("fa").toPersianDigits() }}</span>
        تومان
      </div>
      <hr class="hrrrr" v-if="info.wallet != null" />
      <div v-if="info.wallet >= 0" class="buy__info-container--pri">
        موجودی کیف پول
        <span>{{ info.wallet.toLocaleString("fa").toPersianDigits() }}</span>
        تومان
      </div>
      <div v-if="info.wallet < 0" class="buy__info-container--pri">
        شما مبلغ
        {{ (info.wallet * -1).toLocaleString("fa").toPersianDigits() }}
        تومان بدهکار هستید.
      </div>
      <div class="buy__info-container--btn-con">
        <router-link to="/shopping" class="buy__info-container--btn-con--btn">
          ادامه فرآیند خرید
        </router-link>
      </div>
    </div>
    <app-svg v-if="empty"></app-svg>
  </div>
</template>
<script>
import VueNumberInput from "@chenfengyuan/vue-number-input";
import VueNumericInput from "vue-numeric-input";
import svg from "./svg.vue";
export default {
  data() {
    return {
      nnn: "",
      empty: null,
      updateId: "",
      info: {
        total: "",
        ben: "",
        wallet: "",
        co: "",
      },
      list: [],
    };
  },
  components: {
    VueNumericInput,
    VueNumberInput,
    appSvg: svg,
  },
  methods: {
    onUpdatee(newValue, oldValue) {
      // console.log(newValue, oldValue);
    },
    getValue(e, id) {
      // (this.updateId = event1), event2;
      // console.log(e, id);
    },
    updateCart(e, id) {
      // console.log(
      //   e,
      //   "ggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggggg"
      // );
      var id = id;
      var ee = e;
      // console.log(this.updateId);
      var that = this;
      that.$store.state.load = true;

      $.ajax({
        url: that.$store.state.url + "api/v1/shop/order/update/" + id + "/",
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        data: {
          number: ee,
        },
        type: "PATCH",
        success: function (data, textStatus, request) {
          $.ajax({
            url: that.$store.state.url + "api/v1/shop/order/list/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            type: "GET",
            success: function (data, textStatus, request) {
              that.list = data;
            },
            error: function (request, textStatus, errorThrown) {
              // console.log("blue");
              // console.log(request);
            },
            complete: function () {},
          });
          $.ajax({
            url: that.$store.state.url + "api/v1/shop/cart/info/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            type: "GET",
            success: function (data, textStatus, request) {
              // console.log(data);
              that.info.wallet = data.wallet;
              that.info.co = data.total_count;
              that.info.ben = data.total_profit;
              that.info.total = data.total_price;
            },
            error: function (request, textStatus, errorThrown) {
              // console.log("blue");
              // console.log(request);
            },
            complete: function () {
              that.$store.state.load = false;
            },
          });
          $.ajax({
            url: that.$store.state.url + "api/v1/pages/nav/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            type: "GET",
            success: function (data, textStatus, request) {
              // console.log(data);
              that.logo = data.logo;
              // console.log(data.cart_count);

              // console.log(data.cart_count);
              that.$store.state.co = data.cart_count;
            },
            error: function (request, textStatus, errorThrown) {
              // console.log("blue");
            },
            complete: function () {},
          });
        },
        error: function (request, textStatus, errorThrown) {
          // console.log("blue");
          // console.log(request.responseText);
          if (request.responseText.number) {
            that.$toastr.e(request.responseText.number);
            // console.log(request.responseText.number);
          }
          // for (var i = 0; i <= request.responseText.length; i++) {
          //   console.log(request.responseText[i]);
          // }
        },
        complete: function () {
          that.$store.state.load = false;
        },
      });
    },
    deleteCart(e) {
      var that = this;
      var id = e.target.lastChild.value;
      that.$store.state.load = true;
      $.ajax({
        url: that.$store.state.url + "api/v1/shop/order/delete/" + id + "/",
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        },
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        type: "DELETE",
        success: function (data, textStatus, request) {
          $.ajax({
            url: that.$store.state.url + "api/v1/shop/order/list/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            type: "GET",
            success: function (data, textStatus, request) {
              that.list = data;
              if (data.length == 0) {
                that.empty = true;
              } else {
                that.empty = false;
              }
            },
            error: function (request, textStatus, errorThrown) {
              // console.log("blue");
              // console.log(request);
            },
            complete: function () {},
          });
          $.ajax({
            url: that.$store.state.url + "api/v1/shop/cart/info/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            type: "GET",
            success: function (data, textStatus, request) {
              // console.log(data);
              that.info.wallet = data.wallet;

              that.info.co = data.total_count;
              that.info.ben = data.total_profit;
              that.info.total = data.total_price;
            },
            error: function (request, textStatus, errorThrown) {
              // console.log("blue");
              // console.log(request);
            },
            complete: function () {
              that.$store.state.load = false;
            },
          });
          $.ajax({
            url: that.$store.state.url + "api/v1/pages/nav/",
            crossDomain: true,
            xhrFields: {
              withCredentials: true,
            },
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            type: "GET",
            success: function (data, textStatus, request) {
              // console.log(data);
              that.logo = data.logo;
              // console.log(data.cart_count);

              // console.log(data.cart_count);
              that.$store.state.co = data.cart_count;
            },
            error: function (request, textStatus, errorThrown) {
              // console.log("blue");
            },
            complete: function () {},
          });
        },
        error: function (request, textStatus, errorThrown) {
          // console.log("blue");
          // console.log(request);
        },
        complete: function () {
          that.$store.state.load = false;
        },
      });
    },
  },
  watch: {
    $route(to, from) {},
  },
  created() {
    var that = this;
    this.$store.state.load = true;
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };
    $.ajax({
      url: that.$store.state.url + "api/v1/shop/order/list/",
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("profile"),
      },
      type: "GET",
      success: function (data, textStatus, request) {
        that.list = data;
        if (data.length == 0) {
          that.empty = true;
        } else {
          that.empty = false;
        }
      },
      error: function (request, textStatus, errorThrown) {
        // console.log("blue");
        // console.log(request);
      },
      complete: function () {
        that.$store.state.load = false;
      },
    });
    $.ajax({
      url: that.$store.state.url + "api/v1/shop/cart/info/",
      crossDomain: true,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("profile"),
      },
      type: "GET",
      success: function (data, textStatus, request) {
        console.log(data);
        that.info.wallet = data.wallet;

        that.info.co = data.total_count;
        that.info.ben = data.total_profit;
        that.info.total = data.total_price;
      },
      error: function (request, textStatus, errorThrown) {
        // console.log("blue");
        // console.log(request);
      },
      complete: function () {
        that.$store.state.load = false;
      },
    });
  },
};
</script>
<style lang="scss">
.buy {
  width: 100%;
  min-height: 50vh;
  display: flex;
  //   flex-direction: row-reverse;
  //   background: red;
  margin-top: 7.9em;
  direction: rtl;
  // z-index: 1;
  @media screen and (max-width: 1200px) {
    font-size: 0.9em;
  }
  @media screen and (max-width: 1000px) {
    // flex-direction: column-reverse;
    font-size: 0.9em;
    // margin-top: 13em;
    flex-direction: column-reverse;
  }
  @media screen and (max-width: 500px) {
    flex-direction: column-reverse;
  }
  &__info-container {
    margin-right: 1em;
    width: 25%;
    margin-right: auto;
    margin-left: auto;
    height: 0%;
    // height: 298px;
    margin-top: 1em;
    background: var(--main-color);
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    -webkit-box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
    box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 18%;
    left: 2%;
    margin-bottom: 0em;
    // z-index: 700;
    @media screen and (max-width: 1200px) {
      font-size: 0.9em;
      // height: 210px;
      height: 0%;
    }
    @media screen and (max-width: 1000px) {
      width: 97%;
      font-size: 0.7em;
      height: auto;
      position: static;
      margin-top: 3em;
    }
    @media screen and (max-width: 500px) {
      width: 97%;
      font-size: 0.7em;
      height: auto;
      position: static;
    }
    &--btn-con {
      height: 65px;
      width: 100%;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      // z-index: 5 !important;
      background: transparent;
      font-size: 0.65em;
      z-index: 5;
      // background: red;
      @media screen and (max-width: 1000px) {
        height: 50px;
        position: fixed;
        bottom: 0%;
        left: 0;
        right: 0;
        // z-index: 9000000000 !important;
        font-size: 0.9em;
        background: var(--main-color);
      }
      @media screen and (max-width: 500px) {
        height: 50px;
        position: fixed;
        bottom: 0%;
        left: 0;
        right: 0;
        // z-index: 9000000000 !important;
        font-size: 0.9em;
        background: var(--main-color);
      }
      &--btn {
        width: 98%;
        height: auto;
        background: var(--sub-color);
        border-radius: 8px;
        text-align: center;
        text-decoration: none;
        padding: 1em;
        margin: 0 auto;
        color: var(--main-color);
        // margin-top: 2em;
        z-index: 7000000;
        font-size: 1.2em;
        @media screen and (max-width: 500px) {
          height: auto;
          margin-top: 0;
          display: block;
          // position: fixed;
          // bottom: 0;
          // left: 0;
          // // z-index: 70000000000;
          // background: var(--main-color);
        }
      }
    }

    &--pri {
      display: flex;
      padding: 1em;
      color: #aaa;
      span {
        font-size: 1.4em;
        margin-right: auto;
        margin-left: 0.2em;
        margin-top: -0.3em;
      }
    }
    &--cash {
      display: flex;
      padding: 1em;
      color: var(--font-color);
      span {
        font-size: 1.4em;
        margin-right: auto;
        margin-left: 0.2em;
        margin-top: -0.3em;
      }
    }
    &--totall {
      display: flex;
      padding: 1em;
      color: var(--font-color);
      span {
        font-size: 1.4em;
        margin-right: auto;
        margin-left: 0.2em;
        margin-top: -0.3em;
      }
    }
    &--dec {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0.5em 1em;
      color: var(--shrink);
      margin-bottom: 1em;

      span {
        font-size: 1.4em;
        margin-right: auto;
        margin-left: 0.2em;
        margin-top: -0.3em;
      }
    }
  }
  &__item-container {
    width: 70%;
    // background: red;
    height: auto;
    display: flex;
    flex-direction: column;
    // z-index: -1;
    @media screen and (max-width: 1000px) {
      width: 100%;
      justify-content: center;
      align-items: center;
    }
    @media screen and (max-width: 500px) {
      width: 100%;
      justify-content: center;
      align-items: center;
    }
    &--items {
      margin-right: 1em;
      width: 100%;
      height: 300px;
      margin-top: 1em;
      background: var(--main-color);
      border: 1px solid #e6e6e6;
      border-radius: 8px;
      -webkit-box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
      box-shadow: 0 8px 13px -7px rgba(0, 0, 0, 0.05);
      position: relative;
      overflow: hidden;
      display: flex;
      @media screen and (max-width: 1000px) {
        width: 97%;
        margin-right: 0;
        display: flex;
        // background: red;
        // margin-left: auto;
        // justify-content: center;
        // align-items: center;
        // height: 200px;
        font-size: 0.8em;
        // flex-direction: column;
        height: auto;
        padding-right: 2em;
      }
      @media screen and (max-width: 500px) {
        width: 97%;
        margin-right: 0;
        display: flex;
        // margin-left: auto;
        // justify-content: center;
        // align-items: center;
        font-size: 0.8em;
        flex-direction: column;
        height: auto;
        padding-right: 2em;
      }
      .con11 {
        margin-top: auto;
        margin-bottom: auto;
      }
      .con2 {
        display: flex;
        align-items: center;
        // background: red;
        // justify-content: space-around;
        // background: red;
        // margin-top: auto;
        // margin-bottom: auto;
      }
      &--number {
        // background: red;
        width: 150px;
        margin-top: 1em;
      }
      &--inv {
        display: flex;
        margin-top: 0.5em;
        align-items: center;
        color: #ccc;
        font-size: 0.9em;
        svg {
          color: var(--shrink);
          margin-left: 0.5em;
          //   width: 12px;
          margin-right: 0.6em;
          //   height: 12px;
          border-radius: 50%;
        }
      }
      &--delete {
        font-size: 1em;
        color: #ccc;
        margin-right: 1.5em;
        margin-top: 2em;
        transition: all 0.5s;
        text-decoration: none;
        svg {
          margin-left: 0.5em;
          pointer-events: none;
        }
        &:hover {
          color: var(--shrink);
        }
      }
      &--price {
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        // justify-content: flex-end;
        // background: red;
        margin-right: auto;
        // width: 100%;
        padding: 2em;
        &-ben {
          margin-bottom: 1em;
          color: var(--shrink);
          font-size: 0.8em;
        }
        &-pri {
          font-size: 1em;
          color: black;
          span {
            font-size: 1.5em;
          }
        }
      }
      &--color {
        display: flex;
        font-size: 0.9em;
        // margin: 1em 0 0em 0;
        align-items: center;
        color: #ccc;
        &-div {
          //   border: 1px solid var(--bg-color);
          margin-left: 0.51em;
          width: 12px;
          margin-right: 1em;
          height: 12px;
          border-radius: 50%;
        }
      }
      &--name {
        color: black;
      }
      &--image {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 100%;
        margin-left: 2.5em;
        margin-right: 1em;
        // background: red;
        @media screen and (max-width: 1000px) {
          margin-right: 0em;
        }
        @media screen and (max-width: 500px) {
          align-self: center;
        }
        img {
          width: 200px;
          height: 200px;
          @media screen and (max-width: 1000px) {
            width: 130px;
            height: 130px;
            margin-top: 3em;
          }
          @media screen and (max-width: 500px) {
            width: 200px;
            height: 200px;
            margin-top: 3em;
          }
        }
      }
    }
  }
}
.points {
  margin-top: 1em;
  margin-right: 1em;
  color: var(--shrink);
  @media screen and (max-width: 800px) {
    font-size: 0.9em;
  }
  @media screen and (max-width: 500px) {
    font-size: 0.8em;
  }
}
.hrrrr {
  width: 95%;
  margin-right: auto;
  margin-left: auto;
  border: none;
  height: 1px;
  //   margin-top: 1em;
  background-color: #cfd8dc;
}
.offeeeer {
  text-decoration: none !important;
  color: var(--sub-color);
  position: absolute;
  top: 5%;
  right: 2%;
  font-family: "lalezar";
}
.errors {
  color: var(--shrink);
  // width: 100%;
  // position: static;
  // bottom: 0;
  // position: absolute;
  // bottom: 10px;
  // right: 10px;
  // display: block;
  // background: red;
  display: flex;
  flex-direction: column;
  font-size: 0.9em;
}
///////////////////////////////////////
//////////////////////////////////////////
/////////////////////////////////////////
.style2.vue-numeric-input .numeric-input {
  height: 40px;
  // padding: 2px 60px 2px 2px;
  border-radius: 5px;
  // background: #f8f8f8;
  border: 1px solid #ddd;
  font-family: "yekan";
}

.style2.vue-numeric-input .btn-decrement .btn-icon::before {
  content: "-";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -45%);
  font-weight: lighter;
  color: rgb(70, 70, 70);
  font-size: 2em;
  background-size: 0% 0%;
  // background-color: red;
}

.style2.vue-numeric-input .btn-increment .btn-icon::before {
  content: "+";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -45%);
  font-weight: lighter;
  color: rgb(119, 119, 119);
  font-size: 2em;
  background-size: 0% 0%;
  // background-color: red;
}

.style2.vue-numeric-input button {
  // font-weight: thin;
  // border-radius: 5px;

  width: 40px;
  height: 40px;
  // font-size: 1px !important;
  // margin: 6px;
  // border: none;
  box-shadow: none;
  background: var(--main-color);
}

.style2.vue-numeric-input .btn-decrement {
  // background: #6fbbff;
  // height: 100%;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.style2.vue-numeric-input .btn-increment {
  // background: #6fbbff;
  // height: 100%;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/shop/shop.vue